/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Client_EmptyInputs */

const en_case_field_client_empty = /** @type {(inputs: Case_Field_Client_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No clients found.`)
};

const pt_br2_case_field_client_empty = /** @type {(inputs: Case_Field_Client_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum cliente encontrado.`)
};

/**
* | output |
* | --- |
* | "No clients found." |
*
* @param {Case_Field_Client_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_client_empty = /** @type {((inputs?: Case_Field_Client_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Client_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_client_empty(inputs)
	return pt_br2_case_field_client_empty(inputs)
});